var featuredSlider;

$( function() {
	setTimeout( function() {
		setupSlider();
	}, 150 );
} );

function setImage( element ) {
	var image = element.data( 'image' );

	if ( image ) {
		element.css( 'background-image', 'url(\'' + image + '\')' );
	}
}

function setupSlider() {
	var slider = $( '.slider' ).flickity( {
		wrapAround: true,
		setGallerySize: false,
		arrowShape: 'M0,50l26.3-26.3l2.3,2.5L7.2,47.9H100v4.1H7l21.8,21.8l-2.5,2.5L0,50z'
	} );

	$( '.slider' ).addClass( 'slide-count-' + $( '.slide' ).length );

	var firstAutoplay = true;
	slider.find( 'video' ).each( function( i, video ) {
		if ( firstAutoplay ) {
			video.play();
			$( this ).addClass( 'started' );
			firstAutoplay = false;
		}
	} );

	slider.on( 'select.flickity', function() {
		slider.find( 'video' ).each( function( i, video ) {
			video.pause();
		} );

		var flkty = $( this ).data( 'flickity' );
		setImage( $( flkty.selectedElement ) );
		setImage( $( flkty.selectedElement ).next() );
		setImage( $( flkty.selectedElement ).prev() );

		$( flkty.selectedElement ).find( 'video' ).each( function( i, video ) {
			if ( !$( this ).hasClass( 'started' ) ) {
				video.play();
				$( this ).addClass( 'started' );
			}

			return false;
		} );
	} );

	featuredSlider = $( '.featured-slider' ).flickity( {
		wrapAround: true,
		autoPlay: 6000,
		arrowShape: 'M0,50l26.3-26.3l2.3,2.5L7.2,47.9H100v4.1H7l21.8,21.8l-2.5,2.5L0,50z',
		setGallerySize: false,
		pauseAutoPlayOnHover: false,
	} );

	featuredSlider.on( 'select.flickity', function() {
		$( '.tagline-container' ).removeClass( 'animated fadeInDown' );
		$( '.is-selected .tagline-container' ).addClass( 'animated fadeInDown' );
	} );
}
